var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.4996C6.5 11.4996 9 11.4996 12 11.4996C15 11.4996 16.5 11.4996 16.5 7.5V5.5C16.5 4 15 3 12 3C9 3 7.5 4 7.5 5.5V6.5H12V7.5H5.5C4 7.5 3 9.5 3 12C3 14.5 4 16.5 5.5 16.5H6.5V15.4996ZM10 6C10.5523 6 11 5.55228 11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5C9 5.55228 9.44772 6 10 6Z",
    fill: "#388AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8.50041C17.5 12.5004 15 12.5004 12 12.5004C9 12.5004 7.5 12.5004 7.5 16.5V18.5C7.5 20 9 21 12 21C15 21 16.5 20 16.5 18.5V17.5H12V16.5L18.5 16.5C20 16.5 21 14.5 21 12C21 9.5 20 7.5 18.5 7.5H17.5V8.50041ZM14 20C14.5523 20 15 19.5523 15 19C15 18.4477 14.5523 18 14 18C13.4477 18 13 18.4477 13 19C13 19.5523 13.4477 20 14 20Z",
    fill: "#FFBF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonIcon);
export default __webpack_public_path__ + "static/media/python_icon.9f502f368044ffe986b96868ea8a98e0.svg";
export { ForwardRef as ReactComponent };